'use strict';

/**
 * Name prefixes of first-party cookies written by the consent-gated vendor tags
 * (GA/GTM, Google Ads, Facebook Pixel, Curalate, Pinterest, Attentive, Clarity).
 */
var TRACKING_COOKIE_PREFIXES = [
    '_ga', '_gid', '_gat', '_gcl_',
    '_fbp', '_fbc',
    'crl8.',
    '_pin_unauth', '_pinterest_', '_epik', '_derived_epik',
    '__attentive_', '_attn_',
    '_clck', '_clsk'
];

/**
 * Deletes every tracking-vendor cookie on this origin. Done in the browser rather than
 * via Set-Cookie headers because the server has a hard response-header size limit and
 * cannot tell which Domain each vendor used; here every variant can be tried for free.
 */
function purgeTrackingCookies() {
    var labels = window.location.hostname.split('.');
    var domains = [null];
    for (var d = 0; d < labels.length - 1; d++) {
        domains.push(labels.slice(d).join('.'));
    }

    document.cookie.split(';').forEach(function (pair) {
        var name = pair.split('=')[0].trim();
        var isTracking = TRACKING_COOKIE_PREFIXES.some(function (prefix) {
            return name.indexOf(prefix) === 0;
        });
        if (!name || !isTracking) {
            return;
        }
        domains.forEach(function (domain) {
            document.cookie = name + '=; Max-Age=0; Path=/' + (domain ? '; Domain=' + domain : '');
        });
    });
}

/**
 * Injects the consent-gated tracking scripts (GTM, pixels) without a page reload once
 * the shopper accepts. The markup comes from ConsentTracking-Scripts, which renders
 * nothing unless consent has already been persisted server-side (fail closed).
 */
function loadTrackingScripts() {
    var scriptsUrl = $('.tracking-consent').data('scripts');

    if (!scriptsUrl || window.ueConsentTagsLoaded) {
        return;
    }

    $.ajax({
        url: scriptsUrl,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $('body').append(response);
        }
    });
}

/**
 * Renders a modal window prompting the user to accept or reject site tracking.
 * There is deliberately no dismiss/close control: the shopper must make an explicit
 * choice, and no tracking occurs until (unless) they accept.
 * No-op for Do-Not-Track customers (server-flagged via data-dnt) and when already open.
 */
function showConsentModal() {
    var $consent = $('.tracking-consent');

    if (!$consent.data('caonline') || $consent.data('dnt') === true || $('#consent-tracking').length) {
        return;
    }

    var urlContent = $consent.data('url');
    var urlAccept = $consent.data('accept');
    var urlReject = $consent.data('reject');
    var acceptText = $consent.data('accepttext') || 'OK';
    var rejectText = $consent.data('rejecttext') || 'Decline';

    var htmlString = '<!-- Modal -->'
        + '<div class="consent-tracking-modal" id="consent-tracking" role="dialog">'
        + '<div class="modal-body"></div>'
        + '<button class="decline tracking-modal-decline" data-url="' + urlReject + '" data-consent="reject">'
        + rejectText
        + '</button>'
        + '<button class="affirm tracking-modal-affirm" data-url="' + urlAccept + '" data-consent="accept">'
        + acceptText
        + '</button>'
        + '</div>';
    $('body').append(htmlString);

    $.ajax({
        url: urlContent,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $('#consent-tracking').find('.modal-body').html(response);
            // Trigger custom event to notify about banner display
            $(document).trigger('cookiesBannerShown');
        },
        error: function () {
            $('#consent-tracking').remove();
            // Trigger custom event to notify about banner removal
            $(document).trigger('cookiesBannerHidden');
        }
    });

    $('#consent-tracking button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var requested = $(this).data('consent') === 'accept';
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (response) {
                // The server is authoritative (it may refuse an accept, e.g. DNT customers)
                var accepted = response && typeof response.consent === 'boolean' ? response.consent : requested;

                $('#consent-tracking').remove();
                // Trigger custom event to notify about banner removal
                $(document).trigger('cookiesBannerHidden');
                $(document).trigger(accepted ? 'consent:accepted' : 'consent:rejected');

                // Update the browser-accessible mirror of session.privacy.consent and
                // notify embedded apps (e.g. the ui-app React configurator) via a NATIVE
                // CustomEvent — jQuery-triggered events are invisible to code using a
                // different (or no) jQuery instance.
                window.ueConsentState = accepted ? 'accepted' : 'rejected';
                if (!accepted) {
                    window.trackingConsentGranted = false;
                    document.documentElement.classList.remove('tracking-consented');
                    purgeTrackingCookies();
                }
                document.dispatchEvent(new CustomEvent('consent:changed', { detail: { granted: accepted } }));

                if (accepted) {
                    loadTrackingScripts();
                }
            },
            error: function () {
                // Fail closed: no consent is recorded, tracking stays off and the
                // modal will be shown again on the next page view
                $('#consent-tracking').remove();
                // Trigger custom event to notify about banner removal
                $(document).trigger('cookiesBannerHidden');
            }
        });
    });
}

module.exports = function () {
    // Covers DNT customers, prior Decline, and anything a still-loaded tag re-set before page was reloaded without it
    if (window.ueConsentState === 'rejected') {
        purgeTrackingCookies();
    }

    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }

    $(document).on('click', '.manage-cookie-consent', function (e) {
        e.preventDefault();
        $('.tracking-consent').trigger('click');
    });
};
